<div *ngIf="data" [class.truncate]="truncate">
  <ng-container *ngIf="data.length > 1">
    <span>
      {{ data | concatProperties:propertyName:maxItems }}
    </span>
  </ng-container>
  <ng-container *ngIf="data.length === 1">
    <span>
      {{ propertyName !== 'none' ? data[0][propertyName] : data[0]}}
    </span>
  </ng-container>
  <span nz-popover="" nzPopoverTitle="" [nzPopoverContent]="tpl" class="more-items" *ngIf="data.length > maxItems"> y {{ data.length - maxItems }} {{data.slice(maxItems).length > 1 ? subfixPlural : subfixSingular}}</span>
</div>

<ng-template #tpl>
  <p *ngFor="let element of data.slice(maxItems)"> {{ element[propertyName] || element }} </p>
</ng-template>
